import { HOME_PAGE_URL } from '@/constants/index'
import { useStore } from '@/store/index'
import { useMemoizedFn } from 'ahooks'
import useLangPrefix from '../useLangPrefix'
// import { useRouter } from 'next/router'

const usePageRouter = () => {
  // const router = useRouter()
  const { setPageType } = useStore().baseStore
  const { langPrefix } = useLangPrefix()

  const changePageType = useMemoizedFn((url: HOME_PAGE_URL) => {
    window.history.pushState(null, '', `${langPrefix}${url}`)
    setPageType(url)
  })

  return { changePageType }
}

export default usePageRouter
